// Mock data for La Piña Juice Bar - Pucallpa, Perú

export const menuCategories = [
  {
    id: 'combos',
    name: 'Combos Mañaneros',
    icon: '⭐',
    description: 'Las mejores ofertas del día',
    items: [
      { 
        id: 1, 
        name: 'Combo 1: Desayuno Power', 
        description: 'Jugo de Papaya o Piña (400ml) + Sándwich Triple Clásico. Ideal para empezar el día con energía', 
        price: 11.00,
        discount: 'Ahorras S/ 1.00',
        badge: 'Popular'
      },
      { 
        id: 2, 
        name: 'Combo 2: Antojo de Tarde', 
        description: 'Cualquier jugo "Con Leche" (Fresa, Plátano o Papaya) + Tajada de Keke del día (Naranja o Vainilla)', 
        price: 11.50,
        badge: 'Dulce'
      },
      { 
        id: 3, 
        name: 'Combo 3: Dúo Tropical', 
        description: '2 Jugos Surtidos "La Piña" + 2 Triples de Pollo. Perfecto para compartir', 
        price: 27.00,
        badge: 'Para 2'
      }
    ]
  },
  {
    id: 'especiales',
    name: 'Jugos Especiales',
    icon: '🍍',
    description: 'Frozen & Exóticos',
    items: [
      { 
        id: 4, 
        name: 'La Piña Golden', 
        description: 'Extracto puro de piña Golden, trozos de mango y hierba luisa frozen. ¡Nuestra especialidad!', 
        price: 12.00,
        badge: 'Especialidad'
      },
      { 
        id: 5, 
        name: 'Surtido "La Piña"', 
        description: 'Papaya, Piña, Fresa y Betarraga. El mix poderoso', 
        price: 8.00,
        badge: 'Mix'
      }
    ]
  },
  {
    id: 'clasicos',
    name: 'Jugos Clásicos',
    icon: '🥤',
    description: 'Pura Fruta - 400ml',
    items: [
      { id: 6, name: 'Jugo de Papaya', description: 'Fresca y dulce', price: 7.00 },
      { id: 7, name: 'Jugo de Piña', description: 'Depurativa y refrescante', price: 7.00 },
      { id: 8, name: 'Extracto de Naranja', description: '100% fruta, cero agua', price: 9.00 }
    ]
  },
  {
    id: 'cremosos',
    name: 'Con Leche',
    icon: '🥛',
    description: 'Cremosos y Nutritivos',
    items: [
      { id: 9, name: 'Papaya con Leche', description: 'Espesito y nutritivo', price: 9.00 },
      { id: 10, name: 'Plátano con Leche', description: 'Energético y delicioso', price: 8.50 },
      { id: 11, name: 'Fresa con Leche', description: 'El favorito de todos', price: 10.00, badge: 'Favorito' },
      { 
        id: 12, 
        name: 'Especial de la Casa', 
        description: 'Con huevo, algarrobina y malta/cerveza negra opcional. Un shot de energía', 
        price: 12.00,
        badge: 'Especial'
      }
    ]
  },
  {
    id: 'sandwiches',
    name: 'Sándwiches & Snacks',
    icon: '🥪',
    items: [
      { id: 13, name: 'Triple Clásico', description: 'Palta, huevo y tomate', price: 5.00 },
      { id: 14, name: 'Triple de Pollo', description: 'Con pollo, lechuga y tomate', price: 6.50 },
      { id: 15, name: 'Empanada de Carne', description: 'Rellena de carne jugosa', price: 4.00 },
      { id: 16, name: 'Empanada de Pollo', description: 'Rellena de pollo', price: 4.00 }
    ]
  },
  {
    id: 'postres',
    name: 'Dulces y Postres',
    icon: '🍰',
    items: [
      { id: 17, name: 'Keke de Naranja', description: 'Casero y esponjoso', price: 3.00 },
      { id: 18, name: 'Keke de Vainilla', description: 'Clásico y delicioso', price: 3.00 },
      { id: 19, name: 'Keke de Chocolate', description: 'Intenso sabor a chocolate', price: 4.00 },
      { id: 20, name: 'Keke de Zanahoria', description: 'Nutritivo y sabroso', price: 4.00 },
      { 
        id: 21, 
        name: 'Ensalada de Frutas', 
        description: 'Mix de estación con yogurt, cereal, miel y algarrobina', 
        price: 12.00,
        badge: 'Saludable'
      }
    ]
  },
  {
    id: 'marcianos',
    name: 'Marcianos Gourmet',
    icon: '🍦',
    description: 'Para llevar - Nada de hielo con colorante',
    items: [
      { id: 22, name: 'Marciano de Fresa', description: 'Fruta pura frozen', price: 2.50 },
      { id: 23, name: 'Marciano de Mango', description: 'Fruta pura frozen', price: 2.50 },
      { id: 24, name: 'Marciano de Maracuyá', description: 'Fruta pura frozen', price: 2.50 },
      { id: 25, name: 'Marciano de Coco', description: 'Con leche cremoso', price: 3.50 },
      { id: 26, name: 'Marciano de Maní', description: 'Con leche cremoso', price: 3.50 },
      { id: 27, name: 'Marciano de Lúcuma', description: 'Con leche cremoso', price: 3.50 },
      { id: 28, name: 'Marciano de Oreo', description: 'Especial con galleta', price: 4.50 },
      { id: 29, name: 'Marciano de Chocolate', description: 'Especial intenso', price: 4.50 }
    ]
  }
];

export const businessInfo = {
  name: 'La Piña',
  slogan: 'Sabor que provoca',
  phone: '+51 934 644 835',
  whatsapp: '51934644835',
  email: 'lapina.pcl@gmail.com',
  address: 'Calle 15 de Julio Mz G Lt 16, Calleria',
  city: 'Pucallpa, Perú',
  hours: {
    weekdays: 'Domingo a Jueves: 8:00 AM - 8:00 PM',
    friday: 'Viernes: 8:00 AM - 5:00 PM',
    saturday: 'Sábado: Cerrado (Descanso)',
    note: '¡Los viernes cerramos temprano!'
  },
  delivery: {
    freeZone: 'Envío GRATIS por compras mayores a S/ 20.00 (5-10 cuadras a la redonda)',
    flatRate: 'S/ 5.00 para el resto de Pucallpa (Zona céntrica)',
    coverage: 'Cubrimos todo Pucallpa'
  },
  socialMedia: {
    facebook: 'https://www.facebook.com/share/1Aeez9PDAD/?mibextid=wwXIfr',
    instagram: 'https://www.instagram.com/lapina.pcl/',
    tiktok: 'https://www.tiktok.com/@lapina.pcl?is_from_webapp=1&sender_device=pc'
  }
};

export const testimonials = [
  {
    id: 1,
    name: 'María Gonzáles',
    text: '¡Los jugos más frescos que he probado en Pucallpa! La Piña Golden es mi favorito.',
    rating: 5
  },
  {
    id: 2,
    name: 'Carlos Ramírez',
    text: 'Excelente servicio y productos de calidad. Los sándwiches están deliciosos.',
    rating: 5
  },
  {
    id: 3,
    name: 'Ana Torres',
    text: 'Me encanta venir aquí después del trabajo. Los jugos cremosos son perfectos.',
    rating: 5
  }
];
